// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Alert: {
    close: 'Close'
  },
  Card: {
    select: 'Seleccionar',
    titleLinkTooltip: 'Ir a la página',
    collapseCardTooltip: 'Contraer la tarjeta',
    expandCardTooltip: 'Expandir la tarjeta'
  },
  CardList: {
    loadMore: 'Cargar más',
    notFound: 'No se ha encontrado ningún elemento.',
    toolbarSelect: 'Seleccionar',
    viewCards: 'Tarjetas',
    viewTiles: 'Mosaico',
    viewList: 'Lista',
    toolbarView: 'Vista'
  },
  Carousel: {
    nextSlide: 'Next slide',
    previousSlide: 'Previous slide',
    viewSlide: 'View slide %%slideNumber%%'
  },
  ComboBox: {
    close: 'Close',
    open: 'Open'
  },
  ClosingConfirmation: {
    confirm: 'Salir',
    cancel: 'Volver',
    content: '¿Seguro que quiere cerrar la ventana? Se perderán los cambios.'
  },
  Cuttable: {
    showMore: 'Mostrar más',
    showLess: 'Mostrar menos'
  },
  Dialog: {
    closeButton: 'Close',
    cancelButton: 'Cancelar'
  },
  Drawer: {
    backButton: 'Back',
    closeButton: 'Close',
    hideButton: 'Hide'
  },
  DrawerProgress: {
    cancelButton: 'Cancelar'
  },
  Dropdown: {
    close: 'Cerrar'
  },
  Form: {
    submitButton: 'Guardar',
    applyButton: 'Aplicar',
    cancelButton: 'Cancelar'
  },
  FormField: {
    clear: 'Borrar',
    remove: 'Eliminar',
    addMore: 'Añadir otro',
    showDescription: 'Show description'
  },
  FormFieldPassword: {
    improvePassword: 'Para mejorar su contraseña:',
    passwordTooShort: 'Aumente la longitud de la contraseña.',
    lettersLowerCase: 'Use al menos una letra en minúscula.',
    lettersUpperCase: 'Use al menos una letra en mayúscula.',
    numbers1: 'Use al menos un número.',
    numbers3: 'Use al menos tres números.',
    specialChar1: 'Use al menos un carácter especial (por ejemplo: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Use al menos dos caracteres especiales (por ejemplo: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Use letras en minúsculas y mayúsculas.',
    comboLettersAndNumbers: 'Use números y letras.',
    comboLettersNumbersSpecial: 'Use números, letras y caracteres especiales.',
    yourPasswordIsStrong: 'Puede hacerla aún más segura aumentando su longitud.',
    passwordStrength: 'Seguridad de la contraseña: %%strength%%.',
    strengthVeryStrong: 'MUY SEGURA',
    strengthStrong: 'SEGURA',
    strengthVeryWeak: 'MUY POCO SEGURA',
    strengthWeak: 'POCO SEGURA',
    strengthMedium: 'MEDIANA',
    hidePassword: 'Ocultar contraseña',
    showPassword: 'Mostrar contraseña',
    generateButton: 'Generar',
    copyButtonHint: 'Copie la contraseña',
    copySuccessToast: 'Se ha copiado la contraseña',
    generateButtonHint: 'Genere una contraseña segura'
  },
  InPlaceEdit: {
    cancelButtonHint: 'Descarte los cambios',
    editButtonHint: 'Edite el valor',
    okButtonHint: 'Guarde los cambios'
  },
  InputNumber: {
    decrement: 'Decrement',
    increment: 'Increment'
  },
  InputFile: {
    browseButton: 'Seleccionar archivo...'
  },
  Layout: {
    openSidebar: 'Expand sidebar',
    closeSidebar: 'Collapse sidebar'
  },
  List: {
    totalRows: 'Elementos en total: %%totalRows%%',
    toggleAllRows: 'Toggle all rows',
    toggleRow: 'Toggle row',
    selectedRows: 'Elementos seleccionados: %%selectedRows%% de %%totalRows%%',
    all: 'todos',
    allItemsOnPageSelected: 'Todos los elementos de la página seleccionados',
    allItemsSelected: 'Todos los elementos seleccionados',
    selectAllItems: 'Seleccionar todos los elementos',
    selectAllItemsOnPage: 'Seleccionar todos los elementos de la página',
    deselectAll: 'Deseleccionar',
    selectRow: 'Select row',
    selectAllRows: 'Select all rows'
  },
  ListActions: {
    menuButton: 'Open menu'
  },
  ListEmptyView: {
    filteredTitle: 'No se encontró ningún elemento que coincida con el filtro',
    emptyTitle: 'Parece que aquí no hay nada',
    filteredDescription: 'Restrinja su consulta o elimine algunos de los criterios del filtro e inténtelo de nuevo.'
  },
  ListOperation: {
    cancelButton: 'Cancelar'
  },
  Panel: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  Pagination: {
    totalShort: 'of %%total%%',
    itemsPerPage: 'Elementos por página',
    all: 'Todo',
    total: 'Página %%current%% de %%total%%'
  },
  Popover: {
    closeButton: 'Close'
  },
  ProgressDialog: {
    closeButton: 'Cerrar',
    cancelButton: 'Cancelar'
  },
  Section: {
    collapse: 'Collapse',
    closeButton: 'Close',
    expand: 'Expand'
  },
  Select: {
    clearButton: 'Clear',
    noOptions: 'No hay opciones',
    placeholder: 'Seleccionar...'
  },
  SearchBar: {
    clearButton: 'Clear',
    searchButton: 'Search',
    collapseSearch: 'Hide search input',
    expandSearch: 'Show search input'
  },
  SpotPopup: {
    total: '%%current%% de %%total%%'
  },
  SwitchesPanelItem: {
    showDescription: 'Show description'
  },
  Tabs: {
    closeButton: 'Close tab'
  },
  Toaster: {
    closeGroup: 'Cerrar grupo'
  },
  Toast: {
    closeButton: 'Close'
  }
};